import { CAMPAIGN_STATUS_LABELS, campaignStatusClass } from './campaignUi';
import campStyles from './Campaigns.module.css';

export function CampaignStatusBadge({ status }: { status: string }) {
  const label = CAMPAIGN_STATUS_LABELS[status] ?? status;
  return (
    <span className={`${campStyles.statusPill} ${campaignStatusClass(status)}`}>{label}</span>
  );
}
